import { render } from "./form-part-a.html?vue&type=template&id=79f161fc&scoped=true&ts=true&external"
import script from "./form-part-a.ts?vue&type=script&lang=ts&external"
export * from "./form-part-a.ts?vue&type=script&lang=ts&external"

import "./form-part-a.scss?vue&type=style&index=0&id=79f161fc&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f161fc"]])

export default __exports__